import { Group } from '@mantine/core';
import P3Medium from 'components/typography/P3Medium';
import { IAutomationGatherConfirmation } from 'pages/revisions-module/template-editor/editors/pipeline/types';
import { useMemo } from 'react';
import { GATHER_CONFIRMATION_TYPES } from 'pages/revisions-module/template-editor/editors/pipeline/configurator/properties/GatherConfirmationSubForm';

/**
 * The automation preview for gather-confirmation automation.
 */
export default function GatherConfirmationAutomationPreview({ data }: { data: IAutomationGatherConfirmation }) {
  const typeLabel = useMemo(
    () =>
      GATHER_CONFIRMATION_TYPES.find((type) => type.value === data.confirmationType)?.label || data.confirmationType,
    [data.confirmationType]
  );

  return (
    <>
      <Group spacing={4}>
        <P3Medium>Typ:</P3Medium>
        {typeLabel}
      </Group>

      <span>&#x7c;</span>

      <Group spacing={4}>
        <P3Medium>Názov:</P3Medium>
        {data.label}
      </Group>

      {(data.bypassUserIds ?? []).length > 0 && (
        <>
          <span>&#x7c;</span>
          <Group spacing={4}>
            <P3Medium>Obídenie:</P3Medium>
            {data.bypassUserIds!.length} {data.bypassUserIds!.length === 1 ? 'používateľ' : 'používatelia'}
          </Group>
        </>
      )}
    </>
  );
}
